import { TrattativeMobile } from './TrattativeMobile';
import { TrattativeDesktop } from './TrattativeDesktop';
import { useIsMobile } from '../../hooks/useIsMobile';

/**
 * Trattative. Computer e telefono sono due pagine con la stessa domanda
 * ("quanto possiamo chiudere, e chi chiamo?") e la stessa cache:
 * TrattativeDesktop (bacheca, ridisegnata il 26/10/2026) e TrattativeMobile
 * (righe raggruppate per fase). La pagina del computer di prima (numeri dei
 * periodi, linguette, tabella, aggiunta veloce) è copiata in
 * os-planning/ridisegno/prima-del-ridisegno/lavoro.
 */
export function DealsPage() {
  const isMobile = useIsMobile();
  return isMobile ? <div className="page"><TrattativeMobile /></div> : <TrattativeDesktop />;
}
